<template>
  <div class="border-lists">
    <div class="qty-bg">
      <h5>{{ _T('x') }} {{ orderItem.qty }}</h5>
    </div>
    <!-- <div class="food-right-content"> -->
    <div class="food-box">
      <h5>{{ _T_DB(orderItem, 'name') }}</h5>
      <ul v-if="itemModifiers">
        <template v-for="(modifier, index) in itemModifiers">
          <li :key="index" v-if="modifier.for_item === orderItem.no">
            <span name="modifier-box"> </span>
            {{ _T_DB(modifier, 'name') }}
            {{ modifier.price > 0 ? Num.price(modifier.price) : '' }}
          </li>
        </template>
      </ul>
      <small class="item-note" v-if="orderItem.note"> {{_T('Note:')}} {{ orderItem.note }}</small>
    </div>
    <div class="price-box">
      <h5>
        {{
          orderCurrency || currency + ' ' + Num.price(getTotalPrice(orderItem))
        }}
      </h5>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'OrderItem',
  props: {
    orderItem: {
      type: Object,
      default() {
        return {}
      },
    },
    orderCurrency: {
      type: String,
      default: '',
    },
    itemModifiers: {
      type: Array,
      default() {
        return {}
      },
    },
    itemDiscounts: {
      type: Array,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters(['_T', '_T_DB']),
  },
  methods: {
    getTotalPrice(item) {
      return (
        item.price * item.qty +
        this.modifiersPrice(item.no) -
        this.itemDiscountPrice(item.no)
      )
    },
    itemDiscountPrice(itemNo) {
      let discountPrice = 0
      for (let discount of this.itemDiscounts) {
        if (discount.for_item === itemNo) {
          discountPrice += discount.price
        }
      }
      return discountPrice
    },
    modifiersPrice(itemNo) {
      let modifierPrice = 0
      for (let modifier of this.itemModifiers) {
        if (modifier.for_item === itemNo) {
          modifierPrice += modifier.qty * modifier.price
        }
      }
      return modifierPrice
    },
  },
}
</script>

<style lang="scss" scoped>
.border-lists {
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  width: 100%;
  min-height: $px60;
  .qty-bg {
    width: 30%;
    @media (max-width: 575px) {
      width: 70%;
    }
    background-color: $primary-color;
    display: flex;
    align-items: center;
    justify-content: center;
    h5 {
      margin-bottom: 0;
      color: $white;
      font-weight: 600;
    }
  }
  .price-box {
    align-self: center;
    h5 {
      font-weight: 600;
      margin-bottom: 0;
    }
  }
  &:first-child {
    .price-box {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
  .food-box {
    align-self: center;
    h5 {
      font-weight: 600;
      margin-bottom: 0;
    }
    ul {
      margin-left: $px5;
      margin-top: $px7;
      width: 90%;
      li {
        font-weight: 600;
        line-height: $px22;
        letter-spacing: 0.005em;
        color: $light-font;
        margin-right: $px10;
        span {
          width: $px5;
          height: $px5;
          background: $warning-color;
          display: inline-block;
          border-radius: 50%;
          vertical-align: middle;
          margin-bottom: $px3;
        }
        .modifier-box {
          width: $px5;
          height: $px5;
          background: $warning-color;
          display: inline-block;
          border-radius: 50%;
          vertical-align: middle;
          margin-bottom: $px3;
        }
      }
    }
  }
}
</style>
